import { ComponentType, Dispatch, SetStateAction, createContext, useState } from 'react';

import { CustomEventType } from './hook';

export const EventSourceContext = createContext({
	eventSourceList: [] as CustomEventType[],
	setEventSourceList: {} as Dispatch<SetStateAction<CustomEventType[]>>,
});

export const EventSourceProvider: ComponentType<any> = ({ children }) => {
	const [eventSourceList, setEventSourceList] = useState<CustomEventType[]>([]);

	return (
		<EventSourceContext.Provider value={{ eventSourceList, setEventSourceList }}>
			{children}
		</EventSourceContext.Provider>
	);
};
